export default __webpack_public_path__ + "static/media/logo-img.56026ee6.jpg";